import PortalCheckbox from './PortalCheckbox';

export default PortalCheckbox;
